import React, { Fragment } from "react";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  FunctionField,
  ReferenceField,
  SelectInput,
  ListProps,
  DateInput,
} from "react-admin";
import { Helmet } from "react-helmet";
import {
  busScheduleStatusFilterList,
  formTypeFilterList,
  invoiceStatusFilterList,
  statusFilterList,
} from "./conts";
import CustomDateField from "components/CustomDateField";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { Button } from "@material-ui/core";
import ChangeRequestPanel from "./components/ChangeRequestPanel";
import LinkField from "./components/LinkField";
import CustomTypeField from "./components/CustomTypeField";
import TypeField from "components/TypeField";
import { SchoolIdSelected } from "utils/tools";
import CustomPagination from "components/CustomPagination";

const ChangeRequestFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <DateInput source="WefDate" label="Wef Date" alwaysOn />
    <DateInput source="EndDate" label="End Date" alwaysOn />
    <SelectInput
      label="Status"
      source="Status"
      choices={statusFilterList}
      alwaysOn
    />
    <SelectInput
      label="Form Type"
      source="Type"
      choices={formTypeFilterList}
      alwaysOn
    />
    <SelectInput
      label="Routeplanner Role"
      source="BusScheduleStatus"
      choices={busScheduleStatusFilterList}
      alwaysOn
    />
    <SelectInput
      label="CS Role"
      source="InvoiceStatus"
      choices={invoiceStatusFilterList}
      alwaysOn
    />
  </Filter>
);

const ChangeRequestList = (props: ListProps) => {
  const ChangeRequestShowButton = (record: IChangeRequestForm) => {
    return (
      <Button href={`/#/changeRequestForms/${record.id}/show`}>
        <VisibilityIcon />
      </Button>
    );
  };

  const ChangeRequestEditButton = (record: IChangeRequestForm) => (
    <Button href={`/#/changeRequestForms/${record.id}`}>
      <EditIcon />
    </Button>
  );

  return (
    <>
      <Helmet>
        <title>Change Request Forms</title>
      </Helmet>
      <List
        exporter={false}
        filters={<ChangeRequestFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        bulkActionButtons={false}
        title="Change request forms"
        perPage={50}
        sort={{ field: "wefDate", order: "ASC" }}
        {...props}
        pagination={<CustomPagination />}
      >
        <Datagrid expand={<ChangeRequestPanel />}>
          <TextField source="id" />
          <ReferenceField
            source="studentId"
            reference="students"
            label="Student"
            link={false}
          >
            <FunctionField
              render={(record: any) => (
                <LinkField record={record} resource="students" />
              )}
            />
          </ReferenceField>
          <CustomDateField source="wefDate" emptyText="-" />
          <CustomDateField source="endDate" emptyText="-" />
          <TypeField source="type" type="changeRequest_FormType" />
          <CustomTypeField
            source="busScheduleStatus"
            label="Routeplanner Role"
            type="changeRequest_busSchedule"
          />
          <CustomTypeField
            source="invoiceStatus"
            label="CS Role"
            type="changeRequest_invoice"
          />
          <CustomTypeField
            source="status"
            label="Status"
            type="changeRequest_status"
          />
          <FunctionField
            label="Actions"
            render={(props: any) => (
              <>
                <ChangeRequestShowButton {...props} />
                <ChangeRequestEditButton {...props} />
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default ChangeRequestList;
